import { render, staticRenderFns } from "./new.themes.page.vue?vue&type=template&id=42bd8eda&scoped=true&"
import script from "./new.themes.page.vue?vue&type=script&lang=js&"
export * from "./new.themes.page.vue?vue&type=script&lang=js&"
import style0 from "./new.themes.page.vue?vue&type=style&index=0&id=42bd8eda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bd8eda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardTitle,VDialog})
